import mp3 from "./chime.mp3";

let chime=mp3

export {chime};